import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import DownArrowIcon from '../commons/icons/down_arrow';
import CVForm from './CVForm';

const AccordionContainer = styled('div')`
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13), 0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.10);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  margin-bottom: 30px;
  font-size: 22px;
  font-weight: 600;
`;

const CVAccordion = ({
  values,
  index,
  errors,
  handleChange,
  setErrors,
  setValues,
  currentOpenedAccordionItemIndex,
  setCurrentOpenedAccordionItemIndex,
  isAddingAnotherPosition,
  departmentList,
  isPreviousHotelExperience,
  currentHotelInfo,
}) => {
  const [value, setValue] = useState(values[index]);

  useEffect(() => {
    setValue(values[index]);
  }, [values]);

  return (
    <>
      <AccordionContainer
        onClick={() => {
          if (currentOpenedAccordionItemIndex === index) {
            setCurrentOpenedAccordionItemIndex(-1);
          } else {
            setCurrentOpenedAccordionItemIndex(index);
          }
        }}
      >
        <span>
          {values[0].hotelName} - <i>{value.currentJobTitle}</i>
        </span>{' '}
        <DownArrowIcon />
      </AccordionContainer>

      {currentOpenedAccordionItemIndex === index && (
        <div>
          <CVForm
            values={values}
            index={index}
            errors={errors}
            handleChange={handleChange}
            setErrors={setErrors}
            setValues={setValues}
            showFormTitle={false}
            isAddingAnotherPosition={isAddingAnotherPosition}
            departmentList={departmentList}
            isPreviousHotelExperience={isPreviousHotelExperience}
            currentHotelInfo={currentHotelInfo}
          />
        </div>
      )}
    </>
  );
};

export default CVAccordion;
